import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, NgModule, ViewChild } from '@angular/core';
import { Cms } from '@impact/data';
import { StyleBreakpoints } from '../../models/style-breakpoints';
import { RichTextModule } from '../../rich-text/rich-text.module';
import { FeatureDetectionService } from '../../utils/helpers/feature-detection.service';
import { IImageBreakpoints } from '../../utils/responsive-image.component';
import { UtilsModule } from '../../utils/utils.module';
import { SpotBaseDirective } from '../spot-base.class';

@Component({
    selector: 'app-image-video-text-spot',
    template: `
        <div class="image-video-text-spot">
            <div *ngIf="data.videoId; else noYoutubeVideo">
                <app-youtube-player [videoId]="data.videoId" [autoplay]="data.autoplayVideo"></app-youtube-player>
            </div>
            <ng-template #noYoutubeVideo>
                <app-responsive-image
                    [cssClasses]="'image-video-text-spot__media'"
                    *ngIf="data?.imageVideo?.type === 'Image'; else video"
                    [image]="$any(data.imageVideo)"
                    [breakpoints]="imageBreakpoints">
                </app-responsive-image>
                <ng-template #video>
                    <video
                        class="image-video-text-spot__media"
                        #videoElement
                        [attr.src]="data.imageVideo?.src | resolveMediaUrl"
                        autoplay
                        loop
                        playsinline
                        muted
                        preload="metadata"
                    ></video>
                </ng-template>
            </ng-template>
            <app-rich-text
                class="image-video-text-spot__rich-text"
                [class.image-video-text-spot__rich-text--align-left]="data.leftAlignRichText"
                [html]="data.richText"
            ></app-rich-text>
            <app-rich-text [html]="data.bottomText"></app-rich-text>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
class ImageVideoTextSpotComponent extends SpotBaseDirective implements AfterViewInit {
    static ref = 'imagevideowithtextspot';
    @Input() data: Cms.ImageVideoSpot;
    @ViewChild('videoElement') videoElement: ElementRef<HTMLVideoElement>;

    imageBreakpoints: IImageBreakpoints[];

    constructor(private featureDetectionService: FeatureDetectionService) {
        super();

        this.imageBreakpoints = [
            {
                breakpoint: StyleBreakpoints.Xsmall,
                width: 400
            },
            {
                breakpoint: StyleBreakpoints.Small,
                width: 768
            },
            {
                breakpoint: StyleBreakpoints.Medium,
                width: 1024
            },
            {
                breakpoint: StyleBreakpoints.Large,
                width: 1024
            },
            {
                breakpoint: StyleBreakpoints.Xlarge,
                width: 1312
            }
        ];

    }

    ngAfterViewInit() {
        // Ensure video is muted - fixes autoplay issues
        if (this.featureDetectionService.isBrowser() && this.videoElement) {
            this.videoElement.nativeElement.muted = true;
            this.videoElement.nativeElement.play();
        }

    }
}

@NgModule({
    declarations: [ImageVideoTextSpotComponent],
    imports: [
        CommonModule,
        UtilsModule,
        RichTextModule
    ]
})
class ImageVideoTextSpotModule {}

export const LazySpotComponent = ImageVideoTextSpotComponent;
